class EmblaCarouselElement extends HTMLElement {
  constructor() {
    super();

    const emblaSettings = JSON.parse(
      this.getAttribute("data-embla-settings") || "{}"
    );

    const OPTIONS = {
        align: emblaSettings.align || 'start',
        loop: emblaSettings.loop || true,
        draggable: emblaSettings.draggable || false,
    }
    const viewportNode = this.querySelector('.embla__viewport')
    this.embla = EmblaCarousel(viewportNode, OPTIONS)
    if (emblaSettings.showDots){
      const dots = this.querySelector('.embla__dots');
      this.enableDots(this.embla, dots)
      console.log('enabled_dots')
    }
    if(emblaSettings.showNavigation){
      const prevBtn = this.querySelector('.embla__button--prev')
      const nextBtn = this.querySelector('.embla__button--next')
      this.addPrevNextBtnsClickHandlers(this.embla, prevBtn, nextBtn)
    }
  }


  addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    const scrollPrev = () => emblaApi.scrollPrev()
    const scrollNext = () => emblaApi.scrollNext()
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)

    const removeTogglePrevNextBtnsActive = this.addTogglePrevNextBtnsActive(
      emblaApi,
      prevBtn,
      nextBtn
    )

    return () => {
      removeTogglePrevNextBtnsActive()
      prevBtn.removeEventListener('click', scrollPrev, false)
      nextBtn.removeEventListener('click', scrollNext, false)
    }
  }

  addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
      else prevBtn.setAttribute('disabled', 'disabled')

      if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
      else nextBtn.setAttribute('disabled', 'disabled')
    }

    this.embla
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)

    return () => {
      prevBtn.removeAttribute('disabled')
      nextBtn.removeAttribute('disabled')
    }
  }

  enableDots(emblaApi, dots) {
    let dotNodes = []
    const addDotBtnsWithClickHandlers = () => {
      dots.innerHTML = emblaApi
        .scrollSnapList()
        .map(() => '<button class="embla__dot" type="button"></button>')
        .join('')

      dotNodes = Array.from(dots.querySelectorAll('.embla__dot'))
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener('click', () => emblaApi.scrollTo(index), false)
      })
    }

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap()
      const selected = emblaApi.selectedScrollSnap()
      dotNodes[previous].classList.remove('embla__dot--selected')
      dotNodes[selected].classList.add('embla__dot--selected')
    }
    this.embla
    .on('init', addDotBtnsWithClickHandlers)
    .on('reInit', addDotBtnsWithClickHandlers)
    .on('init', toggleDotBtnsActive)
    .on('reInit', toggleDotBtnsActive)
    .on('select', toggleDotBtnsActive)

    return () => {
      dots.innerHTML = ''
    }
  }
}

customElements.define('embla-carousel', EmblaCarouselElement);
